/**
 * Remove acentuação e normaliza para minúsculas, para comparação/busca tolerante a acento.
 * @param {string} text - texto a ser normalizado
 * @returns {string} texto em minúsculas, sem acentos
 */
export const normalizeText = (text: string): string =>
  text
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();
